import React, { useContext, useState } from "react";

import { Stack, Menu, MenuItem, Divider, Typography } from "@mui/material";

import { styled, alpha } from "@mui/material/styles";

//  icon
import { FaFileCsv } from "react-icons/fa6";
import { MdAddToPhotos } from "react-icons/md";
import { RiStickyNoteAddFill } from "react-icons/ri";

// src
import "../../Style/actionStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import GenerateAttendanceByDay from "./GenerateAttendanceByDay"
import ExportStudentAttendanceCSV from "./CVSFile/ExportStudentAttendanceCSV"
import ImportStudentAttendanceDialog from "./CVSFile/ImportStudentAttendanceDialog"


const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: "rgb(55, 65, 81)",
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": {
            padding: "4px 0",
        },
        ...theme.applyStyles("dark", {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function AttendanceBtnMenu({
    open,
    handleClose,
    anchorEl,
    setRefetch,
    tableData,
    classId
}) {

    // ===================== Change Language ==========================
    const { language, setAlert } = useContext(AuthContext);
    const { t } = translateLauguage(language);

    const [openCreate, setOpenCreate] = useState(false);
    const handleOpenCreate = () => setOpenCreate(true);
    const handleCloseCreate = () => setOpenCreate(false);

    const [openImport, setOpenImport] = useState(false);
    const handleOpenImport = () => setOpenImport(true);
    const handleCloseImport = () => setOpenImport(false);


    return (
        <div>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={() => {
                        handleOpenCreate();
                        handleClose();
                    }}
                    disableRipple
                    className="student-menu-item"
                >
                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <MdAddToPhotos className="icon" />
                        <Typography
                            className={language === "en" ? "action-txt" : "action-txt-kh"}
                        >
                            {t("btn-create")}
                        </Typography>
                    </Stack>
                </MenuItem>

                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                    // onClick={handleClose}
                    disableRipple
                    className="student-menu-item"
                >
                    <ExportStudentAttendanceCSV tableData={tableData} />
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        handleOpenImport();
                        handleClose();
                    }}
                    disableRipple
                    className="student-menu-item"
                >
                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <FaFileCsv className="icon-csv" />
                        <Typography
                            className={language === "en" ? "action-txt" : "action-txt-kh"}
                        >
                            {t("import")}
                        </Typography>
                    </Stack>
                </MenuItem>
            </StyledMenu>


            {
                openCreate && (
                    <GenerateAttendanceByDay open={openCreate} handleClose={handleCloseCreate} classId={classId} setRefetch={setRefetch} />
                )
            }

            {
                openImport && (
                    <ImportStudentAttendanceDialog open={openImport} handleClose={handleCloseImport} classId={classId} setRefetch={setRefetch} />
                )
            }


        </div>
    )
}
